<template>
  <v-form v-model="ui.valid" ref="form">
    <v-container grid-list-md>
      <v-layout row wrap v-if="ui.stage == 1">
        <v-flex xs12 md4 order-xs1 order-lg2>
          <v-flex xs12 md12>
            <v-toolbar color="pink" dark>
              <v-icon>camera_alt</v-icon>
              <v-toolbar-title>Player Image</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card>
              <v-card-text>
                <drop-zone v-if="!!player.avatar.slot" :url="uploadUrl" max-files="1" max-size="2" :file-slot="player.avatar.slot" @success="slotUpdate" accept-types="image/*" :msg="ui.uploadMsg"></drop-zone>
                <v-flex xs12>
                  <div class="text-xs-center" v-if="!player.avatar.slot">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </div>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md12>
            <v-toolbar color="pink" dark>
              <v-icon>contact_page</v-icon>
              <v-toolbar-title>Aadhar File</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card>
              <v-card-text>
                <drop-zone v-if="!!player.aadharFile.slot" :url="uploadAadharUrl" max-files="1" max-size="2" :file-slot="player.aadharFile.slot" @success="aadharSlotUpdate" accept-types="image/jpg,image/jpeg,image/png" :msg="ui.uploadAadharMsg"></drop-zone>
                <v-flex xs12>
                  <div class="text-xs-center" v-if="!player.aadharFile.slot">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </div>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-flex>
        <v-flex xs12 md8 order-xs2 order-lg1>
          <v-toolbar color="pink" dark>
            <v-icon>account_circle</v-icon>
            <v-toolbar-title>Player Profile</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field v-model="player.name" :rules="ui.required" label="Full Name"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-combobox v-model="player.gender" :items="['Female', 'Male']" label="Gender"></v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="player.guardian" :rules="ui.required" label="Father's Name"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-dialog ref="dialog" v-model="ui.dobOpen" :return-value.sync="player.dateOfBirth" persistent lazy full-width width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="formattedDate" label="Date of Birth" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="player.dateOfBirth" scrollable :max="ui.maxDob">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="ui.dobOpen = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialog.save(player.dateOfBirth)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="player.hockeyIndiaRegNo" label="Hockey India Reg No (Optional)"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="player.aadharNumber" :rules="ui.required" label="Aadhar Number"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="player.phoneNumber" :rules="ui.required" label="Phone Number"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="player.identification1" label="Identification Mark 1" :rules="ui.required"></v-text-field>
                </v-flex>

                <v-flex xs6>
                  <v-text-field v-model="player.identification2" label="Identification Mark 2" :rules="ui.required"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="player.address" :rules="ui.required" label="Address" />
                </v-flex>
                <v-flex xs12>
                  <v-combobox v-model="player.district" :items="ui.districts" label="District Of Residence" :rules="ui.required"></v-combobox>
                </v-flex>

                <v-flex xs12>
                  <v-radio-group v-model="player.occupationType" row :rules="ui.required">
                    <v-radio label="Student" value="Student"></v-radio>
                    <v-radio label="Employed" value="Employed"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="player.institution" :rules="ui.required" label="Institution's Name"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="player.institutionAddress" :rules="ui.required" label="Institution's Address"></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn color="red lighten-1" dark :to="{ name: 'player-list' }">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="register">Register</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-snackbar v-model="ui.snackbar" :color="ui.snackbarMode" :timeout="5000">
          <span>{{ ui.feedback }}</span>
          <v-btn dark flat @click="ui.snackbar = false">Close</v-btn>
        </v-snackbar>
      </v-layout>
      <v-dialog v-model="ui.dialog" max-width="290">
        <v-card>
          <v-card-title class="headline">Your registration is complete</v-card-title>

          <v-card-text>
            Your registration number is <strong>{{ player.registerNumber }}</strong
            >. <br />
            You can print the registration form using the button below.
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :to="{ name: 'player-list' }"> Back to Player List </v-btn>
            <v-btn color="primary" text @click="openPlayerForm(player.id)">Print</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-form>
</template>

<script>
import moment from "moment";
import DropZone from "./DropZone";
import _ from "underscore";
import { mapState } from "vuex";

export default {
  data: function () {
    return {
      player: {
        name: "",
        dateOfBirth: moment().subtract(15, "years").toISOString().substr(0, 10), //.format("DD-MMM-YYYY"),
        guardian: "",
        address: "",
        gender: "",
        identification1: "",
        identification2: "",
        aadharNumber: "",
        phoneNumber: "",
        district: "",
        occupationType: "",
        institution: "",
        institutionAddress: "",
        hockeyIndiaRegNo:"",
        avatar: {
          slot: "",
          uploaded: false,
        },
        aadharFile: {
          slot: "",
          uploaded: false,
        },
      },
      ui: {
        maxDob: moment().subtract(5, "years").toISOString().substr(0, 10),
        valid: null,
        dobOpen: false,
        required: [
          function (x) {
            return x ? true : "This field is required";
          },
        ],
        districts: ["Alappuzha", "Ernakulam", "Idukki", "Kannur", "Kasargod", "Kollam", "Kottayam", "Kozhikode", "Malappuram", "Palakkad", "Pathanamthitta", "Thiruvananthapuram", "Thrissur", "Wayanad"],
        snackbar: false,
        feedback: "",
        snackbarMode: "success",
        stage: 1,
        uploadMsg: "Click here to upload image. You can also drag and drop files here to upload. Image should be minimum 300x400 (width x height) and under 2Mb.",
        uploadAadharMsg: "Click here to upload aadhar file. You can also drag and drop files here to upload. Should be an image file and under 2Mb.",
      },
    };
  },
  computed: {
    ...mapState("config", ["identity", "meta"]),
    formattedDate: function () {
      return this.player.dateOfBirth ? moment(this.player.dateOfBirth).format("DD-MMM-YYYY") : "";
    },
    uploadUrl: function () {
      return this.$api("upload").url;
    },
    uploadAadharUrl: function () {
      return this.$api("upload/aadhar").url;
    },
  },
  methods: {
    slotUpdate: function () {
      this.player.avatar.uploaded = true;
    },
    aadharSlotUpdate: function () {
      this.player.aadharFile.uploaded = true;
    },
    createSlot: function () {
      var me = this;
      this.$api("upload")
        .post({})
        .then(function (resp) {
          me.player.avatar.slot = resp.slot;
        });
        this.$api("upload")
        .post({})
        .then(function (resp) {
          me.player.aadharFile.slot = resp.slot;
        });
    },
    register: function () {
      if (!this.$refs.form.validate()) return;

      var me = this;
      var player = _.omit(this.player, "avatar");
      player.avatar = this.player.avatar.slot;
      player.aadharFile = this.player.aadharFile.slot;
      this.$api("players")
        .post(player)
        .then(function (resp) {
          me.showsnackBar("Saved Successfully", "success");
          me.ui.stage = 2;
          me.player.registerNumber = resp.registerNumber;
          me.player.id = resp.id;
          me.ui.dialog = true;
        })
        .catch(function (ex) {
          var msg = ex && ex.responseJSON ? ex.responseJSON.feedback || ex.responseJSON.title : "An error occured!";
          me.showsnackBar(msg, "error");
        });
    },
    openPlayerForm: function (id) {
      var url = this.meta.apiUrl + "/reports/playerbio/" + id + "?key=" + this.identity.token;
      window.open(url);
    },
    showsnackBar: function (msg, mode) {
      this.ui.feedback = msg;
      this.ui.snackbar = true;
      this.ui.snackbarMode = mode || "info";
    },
    clearSlot: function () {},
  },
  mounted: function () {
    this.createSlot();
  },
  components: {
    DropZone,
  },
};
</script>

<style></style>
